enum Events {
  LOCAL_STORAGE_UPDATE_CODE = 'localStorageUpdateCode',
  LOCAL_STORAGE_UPDATE_LANGUAGE = 'localStorageUpdateLanguage',
}

export default Events;
